import { render, staticRenderFns } from "./ClaimGrossRes.vue?vue&type=template&id=969adb8c&"
import script from "./ClaimGrossRes.vue?vue&type=script&lang=js&"
export * from "./ClaimGrossRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports